import {useState} from "react";
import {useTranslation} from "react-i18next";
import Modal from "../../components/Modal.jsx";
import UserProfile from "./UserProfile.jsx";
import ChangePassword from "./ChangePassword.jsx";

export default function AccountSettingsModal({visible, setVisible}) {
    const {t} = useTranslation();
    const [section, setSection] = useState('profile');

    return (
        <Modal
            visible={visible}
            setVisible={setVisible}
            title={t('user.account-settings')}
            className="max-w-3xl"
        >
            <div className="mb-6 flex gap-2 border-b border-slate-200 dark:border-slate-700">
                <button
                    type="button"
                    className={`border-b-2 px-4 py-2 text-sm font-semibold ${section === 'profile' ? 'border-violet-600 text-violet-600' : 'border-transparent text-slate-500 hover:text-slate-800 dark:hover:text-slate-200'}`}
                    onClick={() => setSection('profile')}
                >
                    {t('user.profile')}
                </button>
                <button
                    type="button"
                    className={`border-b-2 px-4 py-2 text-sm font-semibold ${section === 'password' ? 'border-violet-600 text-violet-600' : 'border-transparent text-slate-500 hover:text-slate-800 dark:hover:text-slate-200'}`}
                    onClick={() => setSection('password')}
                >
                    {t('auth.password')}
                </button>
            </div>

            {section === 'profile' ? <UserProfile/> : <ChangePassword/>}
        </Modal>
    );
}
